import { I18nString } from '@models/i18n/i18n-string';
import { AdminUser } from './admin-user';
import { I18nStringMap } from './i18n/i18n-string-map';
import { User } from './user';



export class Group {
    groupId: string;
    groupCode: string;
    groupName: I18nStringMap;
    remarks: string;
    users: AdminUser[] = [];


    constructor() {
        this.groupName = new I18nStringMap();
        let en = new I18nString();
        let zh_tw = new I18nString();
        let zh_cn = new I18nString();
        en.locale = 'en';
        zh_tw.locale = 'zh_TW';
        zh_cn.locale = 'zh_CN';

        this.groupName.i18nStrings = [];
        this.groupName.i18nStrings.push(en);
        this.groupName.i18nStrings.push(zh_tw);
        this.groupName.i18nStrings.push(zh_cn);
    }

    static search(term: string, item: Group) {
        term = term.toLocaleLowerCase();
        return item.groupName.i18nStrings.findIndex(name => name.value.toLocaleLowerCase().indexOf(term) > -1) > -1;
    }
}

export class GroupSearchingCriteria {
    code: string;
    name: string;
}
